<template>
	<v-app id="login" class="primary">
		<v-content>
			<v-container fluid fill-height>
				<v-layout align-center justify-center>
					<v-flex xs12 sm8 md4 lg4>
						<v-card class="elevation-1 pa-3">
							<v-card-text>
								<div class="layout column align-center">
									<tenant-selector-bootstrap v-if="showTenantSelector" :tenants="availableTenants" @onSelectTenant="onSelectTenant"> </tenant-selector-bootstrap>
									<div v-else>
										<img style="height: 43px" src="@/assets/yhrs_logo.png" alt="Your HR System" />
										<div style="margin-top: 50px; width: 100%">
											Please Wait...
											<v-progress-linear v-show="!showTenantSelector" :indeterminate="true"></v-progress-linear>
										</div>
									</div>
								</div>
							</v-card-text>
							<v-card-actions> </v-card-actions>
						</v-card>
					</v-flex>
				</v-layout>
			</v-container>
		</v-content>
	</v-app>
</template>

<script>
	import { mapState } from 'vuex';
	import TenantSelectorBootstrap from '@/components/TenantSelectorBootstrap';
	export default {
		props: {
			showTenantSelector: {},
			availableTenants: {}
		},
		components: {
			TenantSelectorBootstrap
		},
		data: () => ({}),
		methods: {
			onSelectTenant(data) {
				this.$emit('onSelectTenant', data);
			}
		},
		computed: {
			...mapState({
				bootstrapData: (state) => state.bootstrapData
			}),
		}
	};
</script>
<style scoped lang="css">
	#login {
		height: 50%;
		width: 100%;
		position: absolute;
		top: 0;
		left: 0;
		content: '';
		z-index: 0;
	}
</style>
